import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { ToggleSwitch } from "@circle-react-uikit/ToggleSwitchWithLabel";
import { Typography } from "@circle-react-uikit/Typography";
import { useBulkImportTrialPaywallSubscriptionFormContext } from "./BulkImportTrialPaywallSubscriptionFormProvider";

interface NotifyMemberFormProps {
  disabled?: boolean;
}

export const NotifyMemberForm = ({
  disabled = false,
}: NotifyMemberFormProps) => {
  const { hideNotifyMemberForm: shouldHideNotifyMemberForm } =
    useBulkImportTrialPaywallSubscriptionFormContext();
  const [shouldNotifyMember, setShouldNotifyMember] = useState(false);
  const onChange = () => {
    setShouldNotifyMember(!shouldNotifyMember);
  };

  if (shouldHideNotifyMemberForm) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-4 pt-8">
      <Typography.LabelSm weight="semibold">
        {t("bulk_import_page.paywall.notify_member")}
      </Typography.LabelSm>
      <div className="flex flex-row gap-x-4 py-2">
        <ToggleSwitch
          field="paywall[paywall_send_notification_subscription_created_by_admin]"
          disabled={disabled}
          value={shouldNotifyMember}
          onChange={onChange}
        />
        <div className="flex flex-col">
          <span>{t("bulk_import_page.paywall.notify_member_description")}</span>
        </div>
      </div>
    </div>
  );
};
